export const addressValidation = (
  isSigSync?: boolean,
  isDigSync?: boolean,
  signerWillProvideLocation?: boolean,
  isDigitalSchedulingDraft?: boolean
) => {
  if (!isDigSync && !!isSigSync) {
    return true;
  }
  return (!!isDigSync || !!isDigitalSchedulingDraft) && !signerWillProvideLocation;
};
